import { render } from "./ButtonDates.vue?vue&type=template&id=6d86bd1a"
import script from "./ButtonDates.vue?vue&type=script&lang=js"
export * from "./ButtonDates.vue?vue&type=script&lang=js"

import "./ButtonDates.vue?vue&type=style&index=0&id=6d86bd1a&lang=css"
import "./ButtonDates.vue?vue&type=style&index=1&id=6d86bd1a&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__